// extracted by css-extract-rspack-plugin
export default {"cls1":"CitationOutput-cls1_YI1","cls2":"CitationOutput-cls2_fza CitationOutput-cls1_YI1"};